import React from 'react';
import classNames from 'classnames';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Avatar, AvatarImage } from '@fiverr-private/avatar';
import { FiverrIcon } from '@fiverr-private/icons';
import { colorBusiness1200 } from '@fiverr-private/sass/helpers/index';
import { BsmData } from '../types';

import styles from './SendMessageModal.module.scss';

interface Props {
    bsm?: BsmData;
}

export const Recipient = ({ bsm }: Props) => {
    const hasBsm = !!bsm;
    const { profile_image_url, display_name, user_name } = bsm || {};

    return (
        <div className={styles.recipientContainer}>
            <span className={classNames(styles.text, 'tbody-5')}>
                <I18n k="help_menu.modal.to" />
            </span>
            <div className={styles.tag}>
                <div className={classNames(styles.avatarContainer, 'm-r-8')}>
                    {hasBsm ? (
                        <Avatar size="xs" username={display_name || user_name || ''}>
                            <AvatarImage alt={translate('help_menu.avatar_alt') as string} src={profile_image_url} />
                        </Avatar>
                    ) : (
                        <FiverrIcon size={16} color={colorBusiness1200} />
                    )}
                </div>
                <div className="tbody-6">
                    {display_name ? display_name : <I18n k="help_menu.fiverr_success_team" />}
                </div>
            </div>
        </div>
    );
};
